import React, { FC } from 'react';

import { Stack } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { useDiagram } from '@diagram/hooks/use-diagram';
import { ChatService } from '@diagram/services/ChatService';

import { ChatHelpers } from 'helpers/ChatHelpers';

import { Form } from 'components/forms/Form';
import { FormSubmit } from 'components/forms/FormSubmit';
import { TextField } from 'components/forms/fields/TextField';
import { ModalDescription } from 'components/modals/ModalDescription';
import { ModalTitle } from 'components/modals/ModalTitle';

type FormValues = {
    name: string;
};

const CreateChatChannel: FC<ContextModalProps> = ({ context }) => {
    const diagram = useDiagram();

    const submit = async (values: FormValues) => {
        const channel = await ChatService.createChannel(diagram.project, values.name);

        ChatService.activateChannel(channel.id, channel.type);
        ChatService.showAccessPopover();

        context.closeAll();
    };

    return (
        <Stack gap="xs">
            <ModalTitle align="left">Create a channel</ModalTitle>
            <ModalDescription>
                Channels are where conversations happen.
                <br />
                Use a name that is easy to find and understand.
            </ModalDescription>
            <Form<FormValues> defaultValues={{ name: '' }} onSubmit={submit}>
                <Stack gap="xs">
                    <TextField name="name" label="Name" leftSection="#" transform={ChatHelpers.transformChannelName} />
                    <FormSubmit>Create channel</FormSubmit>
                </Stack>
            </Form>
        </Stack>
    );
};

export { CreateChatChannel };
